export const setOption = options => ({
  type: 'SET_OPTION',
  options,
});

export const addOption = options => ({
  type: 'ADD_OPTION',
  field: options.field,
  value: options.values
});

export const setData = options => ({
  type: 'SET_DATA',
  data: options,
});



// WEBPACK FOOTER //
// ./src/component/element/workdoc/FormAction.js